import React from 'react';
import { Input, Message } from 'semantic-ui-react';
import { toNumber } from '../utils/calculations';

const CurrencyField = (props: any) => {
	const [validationError, setValidationError] = React.useState(false);
	return (
		<div>
			<Input
				{...props}
				label={'$'}
				fluid
				placeholder={'0'}
				onChange={(event, data) => {
					if (toNumber(data.value) >= 1000000) {
						setValidationError(true);
					} else {
						setValidationError(false);
					}
					props.onChange(event, data);
				}}
				value={props.value}
			/>
			{validationError ? (
				<Message
					color={'red'}
					header={''}
					content={
						'For sale price over 1 million, please contact us directly for a quote.'
					}
				/>
			) : null}
		</div>
	);
};

export default CurrencyField;
